import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ISidebarSlice {
	collapsed: boolean;
	opened: boolean;
}

const initialState: ISidebarSlice = {
	collapsed: false,
	opened: false,
};

export const sidebarSlice = createSlice({
	name: 'sidebar',
	initialState,
	reducers: {
		toggleCollapsed: (state) => {
			state.collapsed = !state.collapsed;
		},
		toggleOpened: (state, action: PayloadAction<boolean | undefined>) => {
			state.opened = action.payload ?? !state.opened;
		},
	},
});

export default sidebarSlice.reducer;
export const { toggleCollapsed, toggleOpened } = sidebarSlice.actions;
